
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.616 1.206C5.415.846 7.78.799 9.398 2.414a.562.562 0 01.165.398v12.376a.562.562 0 01-.961.398c-.949-.95-2.38-1.192-3.904-1.035-1.512.157-2.993.694-3.884 1.14A.563.563 0 010 15.186V2.813a.563.563 0 01.31-.503l.253.502L.31 2.31l.002-.002.004-.002.015-.006a14.577 14.577 0 013.285-1.094h-.001zM1.125 3.172V14.32c.952-.386 2.187-.756 3.458-.887 1.286-.132 2.686-.025 3.854.63V3.059c-1.195-1.045-2.96-1.076-4.6-.747-.932.19-1.841.48-2.712.861z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.384 1.206C12.586.846 10.22.799 8.602 2.414a.562.562 0 00-.165.398v12.376a.562.562 0 00.961.398c.949-.95 2.38-1.192 3.904-1.035 1.512.157 2.992.694 3.884 1.14a.563.563 0 00.814-.504V2.813a.562.562 0 00-.31-.503l-.253.502.252-.502-.002-.002-.004-.002-.015-.006-.053-.026a14.583 14.583 0 00-3.231-1.068zm2.491 1.966V14.32c-.952-.386-2.187-.756-3.458-.887-1.286-.132-2.686-.025-3.854.63V3.059c1.195-1.045 2.96-1.076 4.6-.747.932.19 1.841.48 2.712.861z","fill":"#000"}})])
          )
        }
      }
    